import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { withRouter, Link as RouterLink } from '@piconetworks/router-adapter'

import xFrame from 'common/xFrame'
import Loader from 'common/modules/loader'

const LinkHoc = (props) => {
    const { openPromptAndHeader, href, defaultPopup } = props

    const disableOnClickHrefs = [
        '/logout',
    ]

    const disableOnClick = disableOnClickHrefs.includes(href)

    return (
        <RouterLink
            {...props}
            {...(!disableOnClick && {
                onClick: (params) => {
                    openPromptAndHeader({
                        ...params,
                        ...(['/gift', '/checkout'].includes(params?._url) && {
                            popupId: defaultPopup?.id,
                        }),
                    })
                },
            })}
        />
    )
}

LinkHoc.propTypes = {
    defaultPopup: PropTypes.object.isRequired,
    openPromptAndHeader: PropTypes.func.isRequired,
    href: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
    defaultPopup: Loader.selectors.getDefaultPopup(state),
})

const mapDispatchToProps = (dispatch) => ({
    openPromptAndHeader: (params) => {
        xFrame.launcher.openPromptAndHeader({
            dispatch,
            entryRoute: {
                url: params?._url,
                as: params?._as,
            },
            popupId: params?.popupId,
        })
    },
})

const Link = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LinkHoc)

export {
    withRouter,
    Link,
}
